import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import { ProductContextService } from '../services/product-context.service';
import template from './support-section-v2.component.html';
var SupportSectionV2Component = (function () {
    function SupportSectionV2Component($element, $timeout, sectionHelper, productContextService) {
        this.$element = $element;
        this.$timeout = $timeout;
        this.sectionHelper = sectionHelper;
        this.productContextService = productContextService;
        this.collapsible = true;
        this.sectionId = '';
    }
    SupportSectionV2Component.prototype.ngOnInit = function () {
        var _this = this;
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                return;
            }
            _this.augmentedHeader = (_this.header || '').replace('[product]', group.title || group.productName || '');
            _this.augmentedSubHeader = (_this.subHeader || '').replace('[product]', group.title || group.productName || '');
        });
    };
    SupportSectionV2Component.prototype.ngOnChanges = function (onChangesObject) {
        var _this = this;
        if (onChangesObject.promise) {
            if (this.promise || this.promise === null) {
                this.deferred = this.sectionHelper.addToScrollQueue(this.sectionId, this.promise);
                this.deferred.promise.then(function () { _this.collapsed = false; }, function () { _this.collapsed = true; });
            }
        }
    };
    SupportSectionV2Component.prototype.collapseChanged = function () {
        var _this = this;
        if (this.collapsed) {
            return;
        }
        this.$timeout(function () {
            var slider = _this.$element.find('slick.slick-initialized');
            slider.slick('refresh');
        });
    };
    SupportSectionV2Component.$inject = ['$element', '$timeout', 'sectionHelper', 'productContextService'];
    __decorate([
        Input('='),
        __metadata("design:type", Boolean)
    ], SupportSectionV2Component.prototype, "collapsed", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SupportSectionV2Component.prototype, "collapsible", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SupportSectionV2Component.prototype, "fluid", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], SupportSectionV2Component.prototype, "header", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], SupportSectionV2Component.prototype, "icon", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SupportSectionV2Component.prototype, "promise", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", Object)
    ], SupportSectionV2Component.prototype, "sectionId", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], SupportSectionV2Component.prototype, "subHeader", void 0);
    SupportSectionV2Component = __decorate([
        Component({
            selector: 'supportSectionV2',
            template: template,
            transclude: true,
        }),
        __param(0, Inject('$element')),
        __param(1, Inject('$timeout')),
        __param(2, Inject('sectionHelper')),
        __param(3, Inject('productContextService')),
        __metadata("design:paramtypes", [Object, Function, Object, ProductContextService])
    ], SupportSectionV2Component);
    return SupportSectionV2Component;
}());
export { SupportSectionV2Component };
